export default {
  nav: {
    home: "Start", casa: "Das Haus", camere: "Zimmer", gallery: "Galerie",
    dove: "Lage", cosa: "Sehenswertes", esperienze: "Erlebnisse",
    recensioni: "Bewertungen", contatti: "Kontakt", prenota: "Buchen",
  },
  hero: {
    eyebrow: "Casa Vacanze Margherita · Santa Croce Camerina, Sizilien",
    lines: ["Dein Zuhause in Sizilien,", "zwischen Meer, Kultur", "und Freiheit."],
    sub: "Erlebe den Südosten Siziliens mit einem Aufenthalt in der Casa Vacanze Margherita — dein idealer Ausgangspunkt für Meer, Barockstädte und die Schönheiten der Küste.",
    cta1: "Das Haus entdecken",
    cta2: "Verfügbarkeit prüfen",
    badges: ["3 Schlafzimmer", "Bis zu 6 Gäste", "Schnelles WLAN", "Klimaanlage", "3 Balkone", "Self-Check-in"],
    scroll: "Zum Entdecken scrollen",
  },
  welcome: {
    eyebrow: "Willkommen",
    title: "Willkommen in der Casa Vacanze Margherita",
    p1: "Öffne die Tür, stell die Koffer ab und beginne, Sizilien zu entdecken. Das Meer ist nur wenige Minuten entfernt, und einige der schönsten Barockstädte der Insel warten nur ein Stück weiter.",
    p2: "Eine 110 m² große Wohnung im zweiten Stock eines ruhigen Hauses: drei Schlafzimmer, eine Küche, die nach Zitronen duftet, ein Wohnzimmer für langsame Abende und drei Balkone, um die Luft des Südens zu atmen.",
    stats: [{ v: "110", l: "m² Zuhause" }, { v: "3", l: "Schlafzimmer" }, { v: "6", l: "Gäste max" }, { v: "3", l: "Balkone" }],
  },
  comfort: {
    eyebrow: "Die Ausstattung",
    title: "Jedes Detail, für deinen Urlaub gedacht",
    items: [
      { icon: "ChefHat", t: "Die Küche für lange Mittagessen", d: "Ausgestattet und hell, mit allem, was ihr braucht, um gemeinsam die Produkte vom Markt zu kochen — und ein Balkon nur zwei Schritte vom Tisch." },
      { icon: "Tv", t: "Abende mit Filmen und Serien", d: "Zwei Smart-TVs mit Netflix für die Abende, an denen du dich einfach nur aufs Sofa legen und für den nächsten Tag auftanken willst." },
      { icon: "Snowflake", t: "Kühle, wenn du sie brauchst", d: "Klimaanlage für guten Schlaf, selbst in den Augustnächten, in denen Sizilien draußen einfach weiter funkelt." },
      { icon: "WashingMachine", t: "Leichteres Gepäck", d: "Waschmaschine vorhanden: Reise mit weniger Gepäck und bleib, wenn du magst, einen Tag länger." },
      { icon: "Armchair", t: "Drei Balkone, drei Momente", d: "Der Kaffee am Morgen, das Buch am Nachmittag, der Aperitivo bei Sonnenuntergang. Jeder Balkon hat seine richtige Stunde." },
      { icon: "KeyRound", t: "Ankommen, wann du willst", d: "Smarter Self-Check-in: keine starren Zeiten, kein Warten. Die Reise gehört dir, das Haus wartet." },
      { icon: "Car", t: "Parkplatz in der Nähe", d: "Parke bequem wenige Schritte vom Haus und vergiss das Auto, bis die nächste Erkundung beginnt." },
      { icon: "PawPrint", t: "Deine Tiere sind willkommen", d: "Hunde und Katzen reisen mit dir und fühlen sich bei uns wie zu Hause. Auch sie verdienen Urlaub." },
      { icon: "Gift", t: "Ein Willkommen, das nach Sizilien duftet", d: "Ein kleines handgemachtes Geschenk erwartet dich: unsere Art zu sagen, dass du hier zur Familie gehörst." },
    ],
  },
  seaCulture: {
    eyebrow: "From Sea to Culture",
    title: "Zwei Welten, ein Zuhause",
    motto: "Am Morgen das Meer. Am Nachmittag eine Barockstadt. Am Abend ein sizilianisches Abendessen.",
    sea: { label: "SEA", title: "Das Meer, nur Minuten entfernt", text: "Goldene Strände, Sonnenuntergänge an der Promenade und der Leuchtturm von Punta Secca, der über das Haus von Kommissar Montalbano wacht.", points: ["Marina di Ragusa", "Punta Secca", "Donnalucata"] },
    culture: { label: "CULTURE", title: "Barock gleich um die Ecke", text: "Goldener Stein, szenerische Treppen, Schokolade und Traditionen: das Val di Noto ist UNESCO-Welterbe.", points: ["Scicli", "Modica", "Ragusa Ibla", "Noto"] },
    cta: "Die Umgebung entdecken",
  },
  roomsTeaser: {
    eyebrow: "Die Zimmer",
    title: "Drei Zimmer, jedes mit eigenem Charakter",
    text: "Keine Hotelzimmer, sondern echte Räume in einem echten Zuhause: hell, ruhig, bereit für deine Erholung.",
    cta: "Zimmer entdecken",
  },
  rooms: {
    matrimoniale: { name: "Doppelzimmer", beds: "Doppelbett · 2 Schlafplätze", d: "Geräumig und hell, mit Balkon, großem Spiegelschrank und der richtigen Stille für erholsamen Schlaf.", features: ["Privater Balkon", "Klimaanlage", "Spiegelschrank"] },
    singola: { name: "Einzelzimmer", beds: "Einzelbett · 1 Schlafplatz", d: "Ein ruhiger, gemütlicher Rückzugsort — perfekt für alle, die mit der Familie reisen, aber ihren eigenen Raum lieben.", features: ["Hell und ruhig", "Ideal für Jugendliche"] },
    castello: { name: "Zimmer mit Etagenbett", beds: "Etagenbett · 2 Schlafplätze", d: "Kinder lieben es, Freunde schätzen es: zwei Schlafplätze, Klimaanlage und Balkon.", features: ["Balkon", "Klimaanlage", "Perfekt für die Kleinen"] },
  },
  position: {
    eyebrow: "Die Lage",
    title: "Zwischen dem Meer und dem Sizilien, das du entdecken willst.",
    text: "Die Casa Vacanze Margherita liegt in Santa Croce Camerina: das Meer erreichst du in wenigen Minuten, und von hier kann jeder Tag eine andere Richtung haben — Küste, Dörfer, Barock.",
    note: "Ungefähre Fahrzeiten mit dem Auto",
    min: "Min. ca.",
    here: "Du bist hier",
    cta: "Hier sind wir",
  },
  destinations: {
    santacroce: { name: "Santa Croce Camerina", d: "Dein Basislager: ein authentisches Dorf mit Märkten, Bäckereien und dem Sizilien des Alltags." },
    puntasecca: { name: "Punta Secca", d: "Das Haus von Kommissar Montalbano, der Leuchtturm und ein Strand wie eine Filmkulisse." },
    marina: { name: "Marina di Ragusa", d: "Promenade, Yachthafen, Restaurants am Meer und ausgestattete Strände für die ganze Familie." },
    donnalucata: { name: "Donnalucata", d: "Ein Fischerdorf mit bunten Booten und Fischmarkt am Morgen." },
    scicli: { name: "Scicli", d: "Ein barocker Salon zwischen Steinbrüchen: Paläste, Kirchen und die meistfotografierte Straße des Südostens." },
    modica: { name: "Modica", d: "Der Dom San Giorgio und die älteste Schokolade Italiens — probiert dort, wo sie entstand." },
    ragusa: { name: "Ragusa Ibla", d: "Eine Krippe aus goldenem Stein: Gassen, Gärten und der Dom, der über dem Tal thront." },
    noto: { name: "Noto", d: "Die Hauptstadt des sizilianischen Barocks: eine Prachtstraße goldener Paläste, die bei Sonnenuntergang erglüht." },
  },
  experiences: {
    eyebrow: "Erlebnisse",
    title: "Nicht nur übernachten. Erlebe Sizilien.",
    text: "Jeder Tag kann anders sein: Wir helfen dir bei der Wahl — mit den Tipps von Menschen, die dieses Land wirklich leben.",
    more: "Alle Erlebnisse entdecken",
    items: [
      { id: "mare", t: "Meer", d: "Freie und ausgestattete Strände, Buchten und Sonnenuntergänge an der Promenade." },
      { id: "barocco", t: "Barock", d: "Scicli, Modica, Ragusa Ibla, Noto: das UNESCO-Sizilien." },
      { id: "enogastronomia", t: "Essen & Wein", d: "Modica-Schokolade, Granita zum Frühstück, frischer Fisch am Abend." },
      { id: "borghi", t: "Dörfer", d: "Punta Secca, Donnalucata und die Orte, in denen die Zeit langsamer wird." },
      { id: "famiglia", t: "Familie", d: "Sichere Strände, echter Platz, Spiele im Haus: glückliche Kinder, entspannte Eltern." },
      { id: "natura", t: "Natur", d: "Oliven- und Johannisbrotbaumhaine, Trockenmauern und Naturschutzgebiete am Meer." },
      { id: "relax", t: "Entspannung", d: "Der Balkon, ein Buch, die Sonne: der einfachste Urlaub, den es gibt." },
      { id: "cultura", t: "Kultur", d: "Keramik, Dorffeste, Museen und die Drehorte von Montalbano." },
      { id: "escursioni", t: "Ausflüge", d: "Küstenwanderungen, Reitausflüge und Bootstage entlang der Küste." },
    ],
  },
  audience: {
    eyebrow: "Perfekt Für",
    title: "Erkenne dich in deinem Urlaub wieder",
    items: [
      { id: "coppie", t: "Paare", d: "Für eine romantische Auszeit in Sizilien, zwischen Sonnenuntergängen am Meer und Abendessen in den Dörfern." },
      { id: "famiglie", t: "Familien", d: "Der Platz und die Freiheit, sich wie zu Hause zu fühlen: Spiele, Küche und sichere Strände." },
      { id: "gruppi", t: "Freundesgruppen", d: "Drei Zimmer und alle Räume, um den Urlaub gemeinsam zu erleben." },
      { id: "viaggiatori", t: "Reisende", d: "Die ideale Basis, um den Südosten Siziliens zu erkunden — jeden Tag in eine neue Richtung." },
    ],
  },
  reviews: {
    eyebrow: "Bewertungen",
    title: "Die Worte unserer Gäste",
    scoreWord: "Außergewöhnlich",
    countText: "Basierend auf 10 verifizierten Bewertungen",
    verified: "Verifizierter Gast",
    reviewsWord: "Bewertungen",
    mapsLink: "Alle auf Google Maps ansehen",
    readAll: "Alle Bewertungen auf Booking.com lesen",
    cats: { cleanliness: "Sauberkeit", comfort: "Komfort", value: "Preis-Leistung", staff: "Personal", facilities: "Ausstattung", location: "Lage" },
    cta: "Alle Bewertungen",
  },
  direct: {
    eyebrow: "Direktbuchung",
    title: "Wenn du direkt bei uns buchst",
    items: [
      { icon: "MessagesSquare", t: "Direkte Betreuung", d: "Du sprichst mit den Menschen, die dich empfangen — ohne Zwischenstellen." },
      { icon: "Smartphone", t: "Einfache Kommunikation", d: "Eine WhatsApp-Nachricht genügt, und du hast die Antwort, die du suchst." },
      { icon: "MapPinned", t: "Persönliche Tipps", d: "Strände, Restaurants und Dörfer: Wir verraten dir die, die wir selbst lieben." },
      { icon: "CalendarCheck", t: "Maximale Flexibilität", d: "Daten, Ankunftszeiten, besondere Wünsche: Lass uns darüber sprechen." },
    ],
    cta: "Angebot anfragen",
  },
  finalCta: {
    title: "Sizilien wartet auf dich.",
    text: "Bring deine Entdeckerlust mit. Um den Rest kümmert sich die Casa Vacanze Margherita.",
    cta: "Verfügbarkeit prüfen",
  },
  footer: {
    tagline: "Sizilien wartet auf dich.",
    explore: "Entdecken",
    contacts: "Kontakt",
    rights: "Alle Rechte vorbehalten.",
    payoff: "From Sea to Culture",
  },
  form: {
    title: "Verfügbarkeit prüfen",
    subtitle: "Fülle das Formular aus: Wir antworten dir so schnell wie möglich mit Verfügbarkeit und Angebot.",
    name: "Vor- und Nachname",
    email: "E-Mail",
    phone: "Telefon (optional)",
    checkin: "Anreise",
    checkout: "Abreise",
    guests: "Gäste",
    pets: "Ich reise mit Tieren",
    message: "Nachricht",
    messagePh: "Erzähl uns etwas über deine Reise...",
    submit: "Anfrage senden",
    sending: "Wird gesendet...",
    success: "Anfrage gesendet! Wir melden uns in Kürze.",
    error: "Etwas ist schiefgelaufen. Bitte versuche es erneut oder schreib uns auf WhatsApp.",
    whatsapp: "Auf WhatsApp fortfahren",
    waMsg: "Hallo, ich hätte gerne Informationen zur Casa Vacanze Margherita für einen Aufenthalt",
  },
  contact: {
    title: "Kontakt",
    heroTitle: "Brauchst du Informationen?",
    heroSub: "Schreib uns direkt: Wir beantworten jede Nachricht persönlich.",
    whatsapp: "WhatsApp",
    phone: "Telefon",
    email: "E-Mail",
    where: "Hier sind wir",
    formTitle: "Schreib uns",
    send: "Nachricht senden",
    success: "Nachricht gesendet! Wir antworten bald.",
  },
  pages: {
    casa: { eyebrow: "Das Haus", title: "Ein echtes sizilianisches Zuhause, bereit dich willkommen zu heißen", seo: "Das Haus | Casa Vacanze Margherita", desc: "Entdecke die 110 m² Wohnung: 3 Schlafzimmer, ausgestattete Küche, Wohnzimmer mit Smart-TV, 3 Balkone und jeder Komfort für deinen Sizilien-Urlaub." },
    camere: { eyebrow: "Die Zimmer", title: "Echte Zimmer für echte Erholung", seo: "Zimmer | Casa Vacanze Margherita", desc: "Drei helle Schlafzimmer für bis zu 6 Gäste: Doppel-, Einzel- und Etagenbettzimmer. Ferienhaus in Santa Croce Camerina, Ragusa." },
    gallery: { eyebrow: "Galerie", title: "Schau dir das Haus an, stell dir den Urlaub vor", seo: "Galerie | Casa Vacanze Margherita", desc: "Echte Fotos der Casa Vacanze Margherita: Zimmer, Küche, Räume, Details und die Umgebung im Südosten Siziliens." },
    dove: { eyebrow: "Lage", title: "Zwischen dem Meer und dem Sizilien, das du entdecken willst.", seo: "Lage | Casa Vacanze Margherita — Santa Croce Camerina", desc: "Die Casa Vacanze Margherita liegt in Santa Croce Camerina (RG): wenige Minuten von Marina di Ragusa und Punta Secca, ideale Basis für Scicli, Modica, Ragusa Ibla und Noto." },
    cosa: { eyebrow: "Sehenswertes", title: "Der Südosten Siziliens, Tag für Tag", seo: "Sehenswertes | Südost-Sizilien | Casa Vacanze Margherita", desc: "Marina di Ragusa, Punta Secca, Scicli, Modica, Ragusa Ibla, Noto: Sehenswürdigkeiten nahe der Casa Vacanze Margherita, mit Fahrzeiten." },
    esperienze: { eyebrow: "Erlebnisse", title: "Nicht nur übernachten. Erlebe Sizilien.", seo: "Erlebnisse Sizilien | Casa Vacanze Margherita", desc: "Meer, Barock, Essen und Wein, Dörfer und Natur: die Erlebnisse während deines Aufenthalts in der Casa Vacanze Margherita." },
    recensioni: { eyebrow: "Bewertungen", title: "Die Worte unserer Gäste", seo: "Bewertungen | Casa Vacanze Margherita", desc: "Was Gäste über die Casa Vacanze Margherita sagen, Ferienhaus in Santa Croce Camerina bei Marina di Ragusa." },
    prenota: { eyebrow: "Buchen", title: "Buche deinen Aufenthalt", seo: "Buchen | Casa Vacanze Margherita", desc: "Prüfe die Verfügbarkeit der Casa Vacanze Margherita und buche deinen Sizilien-Urlaub direkt." },
  },
  casaPage: {
    p1: "Im zweiten Stock eines ruhigen Hauses im Herzen von Santa Croce Camerina ist die Casa Vacanze Margherita eine 110 m² große Wohnung für alle, die ein echtes Zuhause suchen — kein Hotelzimmer.",
    p2: "Der Stil ist modern mit Vintage-Akzenten und sizilianischen Details: die Zitronentischdecke, verzierte Fliesen, ein handgezeichnetes Mandala. Jede Ecke erzählt von der Liebe der Menschen, die dieses Haus pflegen.",
    petsTitle: "Auch deine vierbeinigen Freunde",
    petsText: "Tiere sind immer willkommen: Bring sie mit — hier finden sie Platz und Streicheleinheiten.",
    giftTitle: "Willkommen zu Hause",
    giftText: "Bei der Ankunft erwartet dich ein kleines handgemachtes Geschenk, das nach Sizilien duftet: unsere Art, dich willkommen zu heißen.",
    faqTitle: "Häufige Fragen",
    faq: [
      { q: "Wie kann ich buchen?", a: "Direkt über die Website mit dem Anfrageformular oder per WhatsApp, E-Mail oder Telefon. Wir antworten mit Verfügbarkeit und Angebot." },
      { q: "Wie viele Personen beherbergt das Haus?", a: "Die Wohnung bietet bequem Platz für bis zu 6 Personen: perfekt für Familien, Paare und Freundesgruppen." },
      { q: "Sind Tiere erlaubt?", a: "Ja, deine vierbeinigen Freunde sind immer willkommen." },
      { q: "Wie funktioniert der Check-in?", a: "Mit dem smarten Self-Check-in kommst du an, wann du möchtest — ganz ohne Zeitvorgaben." },
    ],
  },
  dovePage: {
    howTitle: "Anreise",
    car: { t: "Mit dem Auto", d: "Von Catania der A18 Richtung Ragusa folgen und weiter nach Santa Croce Camerina (ca. 1h45). Vom Flughafen Comiso ist das Haus ca. 30 Minuten entfernt." },
    plane: { t: "Mit dem Flugzeug", d: "Die nächsten Flughäfen sind Comiso (CIY) und Catania (CTA). Vom Flughafen kannst du ein Auto mieten oder einen privaten Transfer buchen." },
    bus: { t: "Mit dem Bus", d: "Von Ragusa und Comiso fahren direkte Busse nach Santa Croce Camerina, mit Haltestelle nur wenige Schritte vom Haus." },
    quiet: "Das Haus liegt nur wenige Meter vom historischen Zentrum entfernt, in einer ruhigen, gut erschlossenen Gegend.",
  },
};
